import {
  type CustomerQuoteDetail,
  formatSizeBreakdown,
  SHIPPING_REGION_LABELS,
} from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { formatCount } from '@/shared/lib';

interface QuoteDestinationListProps {
  readonly destinations: CustomerQuoteDetail['destinations'];
}

/**
 * 요청 내용의 배송지 목록(SUPER-86 spec §5-1) — 배송지마다 받는 분·주소·수량 한 줄. 비회원으로 요청한 배송지는 받는 분·상세 주소가
 * 없어 우편번호·주소·수량만 적는다. 추가 요금이 붙는 지역(제주·도서산간)은 지역 이름을 작게 붙인다.
 */
export const QuoteDestinationList = ({ destinations }: QuoteDestinationListProps): ReactElement => (
  <ul aria-label={`배송지 ${destinations.length}곳`} className="flex flex-col gap-2">
    {destinations.map((destination) => (
      <li key={destination.id}>
        {destination.recipientName === null ? '' : `${destination.recipientName} · `}(
        {destination.postalCode}) {destination.address1}
        {destination.address2 ? ` ${destination.address2}` : ''} ·{' '}
        <span className="tabular-nums">{formatCount(destination.quantity)}개</span>
        {destination.sizes.length > 0 ? (
          <span className="ml-2 text-xs text-muted-foreground">
            {formatSizeBreakdown(destination.sizes)}
          </span>
        ) : null}
        {destination.region !== null && destination.region !== 'STANDARD' ? (
          <span className="ml-2 text-xs text-muted-foreground">
            {SHIPPING_REGION_LABELS[destination.region]}
          </span>
        ) : null}
      </li>
    ))}
  </ul>
);
